import styles from "./MileageHeroSection.module.scss";
import Text from "@components/atoms/Text";
import { MileageHeroSideBlock } from "./MileageHeroSideSection";
import { toKebabCase } from "@utils/stringFormatters";
import ImageResponsive from "@components/atoms/ImageResponsive";

const MileageHeroSection = ({
  title,
  carDetails,
  isSellable,
  cityName,
  onModalOpen,
  carAvailability
}: any) => {

  return (
    <div className={styles.contentContainer}>
      <div className={styles.heroImageWrapper}>
        <ImageResponsive
          filePath={`${toKebabCase(carDetails?.makeName)}/${toKebabCase(
            carDetails?.modelName
          )}`}
          imageTag={`Speed`}
          alt={"car-image"}
          fill
          className={styles.heroImage}
          priority
        />
      </div>

      <div className={styles.heroSideSection}>
        <div className={styles.mileageContainerMobileImage}>
          <ImageResponsive
            filePath={`${toKebabCase(carDetails?.makeName)}/${toKebabCase(
              carDetails?.modelName
            )}`}
            imageTag={`Speed`}
            alt={"car-image"}
            fill
            className={styles.mileageContainerImage}
            priority
          />
          <div className={styles.shadowOverlay}></div>
        </div>

        <div className={styles.textSection}>
          <Text level="h1" className={styles.title}>
            {title}
          </Text>
          <Text className={styles.subtitle}>{carDetails?.mileage.range}</Text>
        </div>

        <MileageHeroSideBlock
          mileageOverview={carDetails?.mileage.mileageOverview}
          mileageVariants={carDetails?.mileage.mileageVariants.variants}
          isSellable={isSellable}
          brandName={carDetails.makeName}
          modelName={carDetails.modelName}
          cityName={cityName}
          onModalOpen={onModalOpen}
          carAvailability={carAvailability}
        />
      </div>
    </div>
  );
};

export default MileageHeroSection;
